import * as React from "react";
import HomeHeader from "../../presentations/HomeHeader";

const HomeHeaderContainer = () => {
  return (
    <div>
      <HomeHeader></HomeHeader>
    </div>
  );
};

export default HomeHeaderContainer;
